module.exports = __webpack_public_path__ + "static/media/newIcon.573eaeae.svg";